export enum SUBJECT_KEYS {
    DOWNLOAD_QUEUE = 'DOWNLOAD_QUEUE',
    CAN_CREATE_RECEIPT_WITH_APT = 'CAN_CREATE_RECEIPT_WITH_APT',
}
